import React, { useEffect, useState } from 'react';
import { EditZohoSalesIQAutoSetupSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings/EditZohoSalesIQIntegrationSettings/EditZohoSalesIQAutoSetupSettings/EditZohoSalesIQAutoSetupSettings';
import { useForm } from 'react-hook-form';
import { useGetZohoSalesIQSetupMutation } from 'src/services';
import { useParams } from 'react-router-dom';
import { useLoader } from 'src/provider/LoaderProvider';

export const IntegrationFormZohoSalesIqChat = ({
  integration,
  close = undefined,
  onSubmit = undefined,
}: {
  integration?: any;
  close?: any;
  onSubmit?: any;
}) => {
  const { id } = useParams();
  const { handleSubmit } = useForm();
  const [code, setCode] = useState('');
  const loader = useLoader();
  const [getZohoSalesIQSetup, { data: setupResponse, isFetching: isFetchingZohoSalesIQSetup }] =
    useGetZohoSalesIQSetupMutation() as any;

  useEffect(() => {
    if (id && integration.id) {
      getZohoSalesIQSetup({
        projectId: id,
        integrationId: integration.id,
      });
    }
  }, [id, integration]);

  useEffect(() => {
    if (setupResponse && setupResponse.plug_code) {
      setCode(setupResponse.plug_code);
    }
  }, [setupResponse]);

  useEffect(() => {
    if (isFetchingZohoSalesIQSetup) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isFetchingZohoSalesIQSetup]);

  return (
    <form id={'integration-form'} onSubmit={handleSubmit(close)} className={'w-full overflow-auto'}>
      <EditZohoSalesIQAutoSetupSettings code={code} />
    </form>
  );
};
